export const COLORS = {
  primary: '#154c79',
  primaryLight: '#1a6098',
  primaryHover: '#13446d',
  white: '#fff',
  background: '#E8E8E8',
};
